import React from 'react';

type Props = {
    title: string;
    setTitle: React.Dispatch<React.SetStateAction<string>>;
    isViewOnly: boolean;
    error: string | null;
};

export function TitlePublicationInput({ title, setTitle, isViewOnly, error }: Props) {
    return (
        <>
            <label htmlFor="title">Titre de votre publication</label>
            <input
                className="mb-2"
                type="text"
                name="title"
                value={title}
                onChange={e => setTitle(e.target.value)}
                placeholder="Titre de votre publication"
                required
                readOnly={isViewOnly}
            />
            {error && (
                <div className="text-red-700 bg-red-50 border border-red-200 rounded px-2.5 py-2.5 m-5 text-sm gap-5">
                    {error}
                </div>
            )}
        </>
    );
}
